<div class="w-full h-screen container">
  <div class="flex flex-col justify-center items-center h-full">
    <!-- /Logo Box -->
    <div class="flex flex-col h-1/5 w-4/5 place-content-center">
      <a class="h-full w-full flex flex-col justify-center items-center" href="https://thehubz.com" target="_blank" rel="noopener">
        <img class="w-2/5" [src]="logoUrl" alt="MAKEOS" />
      </a>
    </div>
    <div *ngIf="!validToken && !loading" class="flex flex-col h-4/5 w-4/5 place-content-center max-w-screen-sm">
      <div class="flex flex-col h-full place-content-center">
        <div class="w-full h-20 errorText rounded-xl text-center">
          <p class="pb-8 pt-8 font-bold" i18n>The link you followed is no longer valid</p>
        </div>
        <!-- Buttons-->
        <div class="mb-6 mt-4 w-full">
          <div class="flex flex-row items-center justify-center">
            <button class="flex w-48 lg:w-auto button-primary" type="button" (click)="backToLogin()">
              <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
              <span>Back to login</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="validToken" class="flex flex-col h-4/5 place-content-center w-4/5 max-w-screen-sm">
      <form class="w-full" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div>
          <h2 class="font-bold text-3xl my-8">Reset Password</h2>
        </div>
        <!-- Password -->
        <div class="mb-4">
          <div class="w-full">
            <div class="flex flex-row place-content-between">
              <span class="field-label">New Password</span>
            </div>
            <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
              <mat-icon matSuffix (click)="toggleVisibility()">{{ hide ? 'visibility_off' : 'visibility' }} </mat-icon>
              <input matInput [type]="inputType" placeholder="Password" formControlName="password" />
              <mat-error *ngIf="form.controls['password'].hasError('required')">Password is required </mat-error>
              <mat-error
                *ngIf="
                  form.controls['password'].hasError('hasSpecialCharacters') ||
                  form.controls['password'].hasError('minlength') ||
                  form.controls['password'].hasError('hasNumber') ||
                  form.controls['password'].hasError('hasCapitalCase') ||
                  (form.controls['password'].hasError('hasSmallCase') && !form.controls['password'].hasError('required'))
                "
                >Password should have at least 8 characters, a special character, a number, a capital letter and a small letter</mat-error
              >
              <mat-error class="text-sm" *ngIf="form.controls['password'].hasError('invalidCharacters')">
                <ng-container i18n>Password contains invalid special character, allowed are</ng-container>&nbsp;!&#64;#$&#167;%^&amp;*()_+-&#61;&#59;&#58;&#124;,.&lt;&gt;&#47;?</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <!--Confirm Password -->
        <div class="mb-4">
          <div class="w-full">
            <div class="flex flex-row place-content-between">
              <span class="field-label">Confirm Password</span>
            </div>
            <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
              <mat-icon matSuffix (click)="toggleVisibility()">{{ hide ? 'visibility_off' : 'visibility' }} </mat-icon>
              <input matInput [type]="inputType" placeholder="Confirm Password" formControlName="confirmPassword" />
              <mat-error *ngIf="form.controls['confirmPassword'].hasError('required')">Confirm Password is required</mat-error>
            </mat-form-field>
            <mat-error class="text-[13px]" *ngIf="form.hasError('notSame') && !form.controls['confirmPassword'].hasError('required')">Passwords are not same </mat-error>
          </div>
        </div>
        <!-- Button-->
        <div class="mb-4 w-full">
          <div class="flex flex-row place-content-between items-center">
            <button mat-flat-button class="flex-auto w-2/5 button-primary" [disabled]="form.invalid || showSubmitButton" type="submit">Submit</button>
          </div>
        </div>
        <!-- Spinner -->
        <div class="w-full flex flex-row justify-center items-center" *ngIf="loading">
          <mat-spinner [diameter]="30" color="warn"></mat-spinner>
        </div>
      </form>
    </div>
    <sp-footer></sp-footer>
  </div>
</div>
